import { Component, OnInit, ViewChild, EventEmitter, Input, SimpleChanges, Output, HostListener } from '@angular/core';
import { FormGroup, FormBuilder } from '@angular/forms';
import { AddressService } from './address.service';
import { Ng4LoadingSpinnerService } from 'ng4-loading-spinner';
import { Address } from './address.model';
import { Subscription } from 'rxjs';
import { environment } from "../../../environments/environment"
import { Router } from '@angular/router';
import { ToastrService } from 'ngx-toastr';
export let isDebugMode = environment.isDebugMode

declare var $: any

@Component({
    selector: 'flow-address',
    templateUrl: './address.component.html',
    styleUrls: ['./address.component.scss']
})
export class AddressComponent implements OnInit {

    private subscriptions: Subscription[] = []
    //@Input() addressObj: Address
    @Input() label: string
    @Input() form: FormGroup
    @Output() eventChange = new EventEmitter();
    addressForm: FormGroup
    disabled: boolean = false
    codeunique: boolean = false

    constructor(
        private fb: FormBuilder,
        private addressService: AddressService,
        private loading: Ng4LoadingSpinnerService,
        private toastr: ToastrService
    ) {

    }

    @HostListener('keydown', ['$event']) onKeyDown(e: any) {

        if ((e.which == 13 || e.keyCode == 13) || (e.which == 40 || e.keyCode == 40)) {
            //e.preventDefault();
            let campo = $("input")
            let indice = campo.index(e.srcElement);
            if (campo[indice + 1] != null) {
                let proximo = campo[indice + 1]
                proximo.focus()
                proximo.select()
            } else {
                let proximo = campo[indice - 1]
                proximo.focus()
                proximo.select()
            }
        }

        if ((e.which == 38 || e.keyCode == 38)) {
            e.preventDefault()
            let campo = $("input")
            let indice = campo.index(e.srcElement)
            if (campo[indice - 1] != null) {
                let proximo = campo[indice - 1]
                proximo.focus()
                proximo.select()
            }
        }

    }

    ngOnInit() {
        this.initForms()
        this.subscribes()
    }

    ngAfterViewInit() {
        this.addressForm = this.form
    }

    ngOnDestroy() {
        isDebugMode ? console.log(`ngOnDestroy()`) : undefined
        this.subscriptions.forEach(sub => sub.unsubscribe())
    }

    subscribes() {
        this.subscriptions.push(
            this.addressForm.valueChanges.subscribe(val => {
                //console.log(val)
            })
        )
    }
    onExitCep(event) {
        this.loading.show()

        let _addressid = this.addressForm.getRawValue().addressid

        if (this.addressForm.controls['cepid'].value != "") {

            this.addressService.get(this.addressForm.controls['cepid'].value)
                .subscribe(
                    data => {

                        console.log(data)

                        this.codeunique = (data.codeunique == 1)

                        this.addressForm.reset()

                        setTimeout(() => {
                            Object.keys(this.addressForm.controls).forEach(key => {
                                this.addressForm.controls[key].enable()
                            });
                            this.addressForm.patchValue(data)
                            this.addressForm.controls['addressname'].setValue(data.addressfull)
                            this.addressForm.controls['addressname'].disable()
                            this.addressForm.controls['districtid'].disable()
                            this.addressForm.controls['estateid'].disable()
                            this.addressForm.controls['localid'].disable()
                            if (data.codeunique == 1) {
                                this.addressForm.controls['addressname'].enable()
                                this.addressForm.controls['districtid'].enable()
                            }
                            this.addressForm.patchValue({
                                addressid: _addressid
                            })
                        }, 200)

                        this.loading.hide()
                    }
                    , err => {
                        console.log(err)
                        this.addressForm.reset()
                        this.toastr.error(err.error.message)
                        this.loading.hide()
                    }

                )

        } else {
            this.addressForm.reset()
            this.loading.hide()
        }
    }

    initForms() {

        this.addressForm = this.form

        /* ========================================================================*/
        /* Set Form masterForm */
        /* ========================================================================*/
        // this.addressForm = this.fb.group({
        //     addressid: this.fb.control({ value: "", disabled: true }),
        //     cepid: this.fb.control({ value: "", disabled: false }),
        //     address: this.fb.control({ value: "", disabled: true }),
        //     addressfull: this.fb.control({ value: "", disabled: true }),
        //     number: this.fb.control({ value: "", disabled: false }),
        //     complement: this.fb.control({ value: "", disabled: false }),
        //     districtid: this.fb.control({ value: "0", disabled: true }),
        //     xdistrictid: this.fb.control({ value: "", disabled: true }),
        //     localid: this.fb.control({ value: "0", disabled: true }),
        //     xlocalid: this.fb.control({ value: "", disabled: true }),
        //     estateid: this.fb.control({ value: "__", disabled: true }),
        //     xestateid: this.fb.control({ value: "", disabled: true }),
        //     pagecode: this.fb.control({ value: "", disabled: false }),
        //     refaddress: this.fb.control({ value: "", disabled: false }),
        //     obsaddress: this.fb.control({ value: "", disabled: false }),
        //     googmaps: this.fb.control({ value: "", disabled: false })
        // })
        /* End of Set Form masterForm */

    }

    selectChange(form) {

        this.addressForm.patchValue(form)

        Object.keys(form).forEach(key => {
            if (key == "estateid") {
                this.addressForm.controls['localid'].reset()
                this.addressForm.controls['xlocalid'].reset()
                this.addressForm.controls['districtid'].reset()
                this.addressForm.controls['xdistrictid'].reset()
            }
            if (key == "localid") {
                this.addressForm.controls['districtid'].reset()
                this.addressForm.controls['xdistrictid'].reset()
            }
        })

    }

    google() {

        window.open(this.addressForm.get('googmaps').value, "_blank");



    }

    selectInput(event) {
        isDebugMode ? console.log(`selectInput()`) : undefined
        event.target.select()
    }


}
